/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';
const initialState = {
  planType: [],
  rebateProgram: '',
  rebateProgrameName: '',
  rebateProgramList: [],
  errorMessagesInRedux: [],
  plan: '',
  errors: [],
  searchResult: [],
  selectedSearchType: '',
  isLoading: false,
  fromQtrValue: '',
  toQtrValue: '',
  isAllQuartersValue: false,
  ndcHistoryDisputeCodes: [],
  labelerSelectedRow: [],
  selectedNDC: [],
  ndcLeftTableData: [],
  labelerTableData: [],
  exportAllData: {},
  openModalValue: false,
  displayObj: {
    searchResult: [],
    selectedNDC: [],
    rebateProgram: '',
    rebateProgrameName: '',
    labelerTableData: [],
    rebateProgramList: [],
    fromQtrValue: '',
    toQtrValue: '',
    isAllQuartersValue: false,
    ndcHistoryDisputeCodes: [],
    countValue: 1,
  },
};
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    //Plan type and rebate program
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    case ActionTypes.GET_REBATE_PROGRAM_NDC_HISTORY:
      return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_SELECTED_INPUT_NDC_HISTORY:
      return { ...state, ...action.payload };
    case ActionTypes.SET_NDC_HISTORY_REPORT_DATA:
      let displayObj = {
        ...state.displayObj,
        searchResult: action.payload,
      };
      return { ...state, searchResult: action.payload, displayObj };
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: action.payload };
    case ActionTypes.SET_NDC_HISTORY_DISPUTE_CODE_DATA:
      let displayObjCopy = {
        ...state.displayObj,
        ndcHistoryDisputeCodes: action.payload,
      };
      return {
        ...state,
        ndcHistoryDisputeCodes: action.payload,
        displayObj: displayObjCopy,
      };
    case ActionTypes.SET_OPEN_MODAL:
      return { ...state, openModalValue: action.payload };
    case ActionTypes.SET_NDC_HISTORY_REPORT_DATA_ALL:
      const exportAllData =
        action.key === 'noData'
          ? {}
          : { ...state.exportAllData, [action.key]: action.payload };
      return {
        ...state,
        exportAllData,
      };
    case ActionTypes.REFRESH_NDC_HISTORY:
      return { ...initialState, displayObj: state.displayObj };
    case ActionTypes.REFRESH_NDC_HISTORY_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    case ActionTypes.NDC_HIST_DETAIL_DISP:
      return { ...state, ndcHistDtlData: action.payload };
      
    case ActionTypes.NDC_SELECT_TYPE:
      return { ...state, selectedSearchType: action.payload };

    case ActionTypes.SET_PAGINATION_INDEX_NDC_HISTORY:
      return {
        ...state,
        displayObj: { ...state.displayObj, countValue: action.payload },
      };
    default:
      return state;
  }
};

export default reducer;
